import React from 'react';

import { Avatar, List, Switch, Typography } from 'antd';
import styled from 'styled-components';

import Checkbox from 'components/lib/Checkbox';

import type { CompanyPreferenceItem } from './types';

const StyledListItem = styled(List.Item)`
  background-color: white;

  &&.ant-list-item {
    padding: 15px 10px 15px 15px;
  }

  &:hover {
    background-color: var(--background-gray-light);
  }
`;

const AvatarLetter = styled(Typography.Text)`
  font-size: 10px;
  line-height: 10px;
  font-weight: 500;
  color: #0ab776;

  &&.ant-avatar-string {
    display: flex;
  }
`;

const CompanyName = styled(Typography.Text)`
  margin-left: 10px;
  font-size: 14px;
  font-weight: 500;
`;

const LeftRow = styled.div`
  display: flex;
  flex-flow: row;
  align-items: center;
`;

const RightRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  min-width: 90px;
`;

type IncentiveScrappingListItemProps = {
  item: CompanyPreferenceItem;
  isMultipleSelection: boolean;
  isSelected: boolean;
  isUpdating: boolean;
  onToggleOne: (companyId: number) => void;
  onTogglePreference: (companyId: number, enabled: boolean) => void;
};

const IncentiveScrappingListItem = ({
  item,
  isMultipleSelection,
  isSelected,
  isUpdating,
  onToggleOne,
  onTogglePreference,
}: IncentiveScrappingListItemProps) => {
  const firstLetter = item.company_name?.charAt(0)?.toUpperCase() || '?';

  return (
    <StyledListItem style={{ cursor: isMultipleSelection ? 'auto' : 'default' }}>
      <LeftRow>
        {isMultipleSelection && (
          <Checkbox checked={isSelected} onChange={() => onToggleOne(item.company)} style={{ marginRight: '15px' }} />
        )}
        <Avatar
          size={30}
          style={{
            backgroundColor: '#e2f5ee',
            border: 'solid 1px var(--positive-green)',
            color: 'var(--positive-green)',
          }}
        >
          <AvatarLetter>{firstLetter}</AvatarLetter>
        </Avatar>
        <CompanyName>{item.company_name}</CompanyName>
      </LeftRow>
      <RightRow>
        <Switch
          checked={item.incentive_scrapping}
          loading={isUpdating}
          onChange={(checked) => onTogglePreference(item.company, checked)}
        />
      </RightRow>
    </StyledListItem>
  );
};

export default IncentiveScrappingListItem;
